import { gql, useQuery } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

const SERVICE_CHECK = gql`
  query ServiceCheck($id: ID!, $token: String) {
    serviceCheck(id: $id, token: $token) {
      id
      status
      verdict
      inputServiceName
      inputCategory
      suggestedCategory
      reasoning
      resolvedSnippetId
      escalatedAt
      forcedAt
    }
  }
`;

export type ServiceCheckStatus = 'PENDING' | 'COMPLETED' | 'FAILED';
export type ServiceCheckVerdict = 'RELEVANT_ADDED' | 'NOT_RELEVANT' | 'WRONG_CATEGORY' | 'DUPLICATE';

export interface ServiceCheck {
  id: string;
  status: ServiceCheckStatus;
  verdict: ServiceCheckVerdict | null;
  inputServiceName: string;
  inputCategory: string;
  suggestedCategory: string | null;
  reasoning: string | null;
  resolvedSnippetId: string | null;
  escalatedAt: string | null;
  forcedAt: string | null;
}

export interface ServiceCheckData {
  serviceCheck: ServiceCheck;
}

export interface ServiceCheckVariables {
  id: string;
  token?: string | null;
}

export function useServiceCheckQuery(id: string | null | undefined, pollIntervalMs = 3000) {
  const { token, waitingForShareToken } = useShareTokenJwt();
  return useQuery<ServiceCheckData, ServiceCheckVariables>(SERVICE_CHECK, {
    variables: { id: id ?? '', token },
    skip: !id || waitingForShareToken,
    pollInterval: id ? pollIntervalMs : 0,
    fetchPolicy: 'network-only',
  });
}
